// App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ThreeScene from './ThreeScene';
import ViewModelPage from './ViewModelPage';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<ThreeScene />} />
        <Route path="/viewmodel" element={<ViewModelPage />} />
      </Routes>
    </Router>
  );
}

export default App;
